// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__TnRpO","footer":"Dialog_footer__nCJ-T","footerNote":"Dialog_footerNote__6x1x8","footerActions":"Dialog_footerActions__05dHp"};